import css from 'styled-jsx/css';

const styles = css.global`.form-simulacao {
  overflow: visible;
  position: relative;
}

.form-simulacao .title {
  font-family: 'SantanderHeadline';
  font-weight: 400;
  font-size: 32px;
  line-height: 48px;
  letter-spacing: 0px;
  color: #cc0000;
}

.form-simulacao .subtitle {
  font-family: 'SantanderText';
  font-weight: 400;
  font-style: Regular;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  color: #444444;
}

.form-simulacao .subtitle b {
  font: inherit;
  color: inherit;
  font-weight: 600;
}

.form-simulacao .stack {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
}

.form-simulacao .form-container {
  display: flex;
  flex-direction: column;
  width: 690px;
  box-sizing: border-box;
}

.form-simulacao .img-panel {
  flex: 1;
  margin-top: 58px;
}

.form-simulacao .top-spacing {
  margin-top: 24px;
}

.form-simulacao .img-panel img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.form-simulacao .form-render {
  max-width: 420px;
  gap: 24px;
  display: flex;
  flex-direction: column;
}

.form-simulacao .text-terms {
  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: -2%;
  color: #444444;
}

.form-simulacao #text-show-modal-terms {
  font: inherit;
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
}

.form-simulacao .disclaimer {
  font-family: 'SantanderMicroText';
  font-weight: 400;
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: -2%;
  color: #444444;
  margin: 24px 0 0;
  max-width: 440px;
}

@media (max-width: 991px) {
  .form-simulacao .submit-form-solar {
    margin-left: auto;
    margin-right: auto;
  }
}
`;

export default styles;